<template>
  <div class="toast" :class="{ '-active': active }">
    <span
      class="toast__item"
      v-bind:key="index.toString()"
      v-for="(item, index) in message"
      >{{ item }}</span
    >
  </div>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      active: false
    };
  },
  props: {
    message: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    }
  },
  watch: {
    message: function() {
      this.active = true;
      setTimeout(() => {
        this.active = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
.toast {
  $_toast-transition: opacity, transform;
  background-color: theme-color("error");
  bottom: 0;
  color: theme-color("body");
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: fixed;
  transform: translateY(100%);
  transition: cta-transition($_toast-transition);
  width: 100vw;
  z-index: z-index("toast");
  padding: spacer("s");

  &__item {
    background-color: rgba(theme-color("body"), 0.2);
    border-radius: 2px;
    font-size: px-to-rem(13px);
    min-height: 100%;
    padding: spacer("s");

    @include if-tablet {
      font-size: px-to-rem(16px);
    }

    &:not(:last-child) {
      margin-right: spacer("s");
    }
  }

  &.-active {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
